import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import HealthInsuranceCompanySelect from '../../../../Term/Components/HealthInsuranceCompanySelect/HealthInsuranceCompanySelect';

interface HealthInsuranceCompanySelectFieldProps extends BaseFieldProps {
	includeSelfPayer?: boolean;
}

const HealthInsuranceCompanySelectField: React.FC<
	HealthInsuranceCompanySelectFieldProps
> = ({ includeSelfPayer, ...props }) => (
	<BaseField {...props}>
		<HealthInsuranceCompanySelect includeSelfPayer={includeSelfPayer} />
	</BaseField>
);

export default HealthInsuranceCompanySelectField;
